import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../../../actions/utilAction';


export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_DAILYSUMMARY_DOMAIN_LIST_API = `${API_URL}/api/PatientSkillAcquisitionDomain/GetPatientSkillAcqDomains`;
export const GET_DAILYSUMMARY_PROGRAM_LIST_API = `${API_URL}/api/PatientSkillAcquisitionProgram/GetPatientSkillAcqPrograms`;
export const GET_DAILYSUMMARY_TARGET_LIST_API = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqTargets`;
export const GET_BEHAVIOR_LIST_API = `${API_URL}/api/PatientBehaviorsReduction/GetPatientBehaviorsReduction`;
export const GET_DAILYSUMMARY_DATA =`${API_URL}/api/PatientSkillAcquisitionDomain/GetDailySummarySkillAcquisitionData`;
export const GET_DAILYSUMMARY_BEHAVIOR_DATA =`${API_URL}/api/CollectData/GetDailySummaryBehaviorData`;
export const UPDATE_DAILYSUMMARY_SKILLACQUISITION_DATA =`${API_URL}/api/CollectData/UpdatePatientSkillsAcquisitionDailySummaryData`;
export const UPDATE_DAILYSUMMARY_BEHAVIOR_DATA =`${API_URL}/api/CollectData/UpdatePatientBehaviorDailySummaryData`;

export const DailySummaryDataActionTypes = {
    get_masterData: createRequestActionTypes('GET_MASTERDATA'),
    get_DailySummaryDomainList: createRequestActionTypes('GET_DAILYSUMMARY_DOMAIN_LIST_API'),
    get_DailySummaryProgramList: createRequestActionTypes('GET_DAILYSUMMARY_PROGRAM_LIST_API'),
    get_DailySummaryTargetList: createRequestActionTypes('GET_DAILYSUMMARY_TARGET_LIST_API'),
    get_behaviorList: createRequestActionTypes('GET_BEHAVIORLIST'),
    get_DailySummaryData : createRequestActionTypes('GET_DAILYSUMMARY_DATA'),
    get_DailySummaryBehaviorData : createRequestActionTypes('GET_DAILYSUMMARY_BEHAVIOR_DATA'),
    update_DailySummarySkillAcquisitionData : createRequestActionTypes('UPDATE_DAILYSUMMARY_SKILLACQUISITION_DATA'),
    update_DailySummaryBehaviorData : createRequestActionTypes('UPDATE_DAILYSUMMARY_BEHAVIOR_DATA'),
}





// export const MODULE = 'DCPATIENT_SKILLAQUISITIONTARGET';


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/DailySummaryData/constants/ApiConstants.js